import { GlossaryItem } from "@/lib/stores/objectsStore";

/**
 * Generates the next untitled name for new glossary items
 * Returns a name like "Untitled_Object_001" with logical numbering
 * 
 * @param gameId - The current game ID
 * @param glossaryItems - All glossary items to check for existing names
 * @returns A unique untitled object name
 */
export const generateDefaultObjectName = (
  gameId: string | undefined,
  glossaryItems: GlossaryItem[] | undefined
): string => {
  const prefix = "Untitled_Object_";
  if (!gameId || !glossaryItems) return `${prefix}001`;

  // Find existing "Untitled_Object_XXX" names (also check legacy "Untitled-X" format)
  const existingNumbers: number[] = [];
  const newFormatRegex = new RegExp(`^${prefix}(\\d{3})$`);
  const legacyFormatRegex = /^Untitled-(\d+)$/;

  glossaryItems
    .filter((item) => item.game_id === gameId)
    .forEach((item) => {
      const newMatch = item.name?.match(newFormatRegex);
      const legacyMatch = item.name?.match(legacyFormatRegex);
      if (newMatch) {
        existingNumbers.push(parseInt(newMatch[1], 10));
      } else if (legacyMatch) {
        existingNumbers.push(parseInt(legacyMatch[1], 10));
      }
    });

  // Find the next available number
  let nextNumber = 1;
  while (existingNumbers.includes(nextNumber)) {
    nextNumber++;
  }

  // Format with leading zeros (001, 002, etc.)
  return `${prefix}${String(nextNumber).padStart(3, '0')}`;
};

